function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#marketer_svg__clip0_4607_16248)",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeLinecap: "square"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.647 21.691v13.327a2.665 2.665 0 002.665 2.666v0a2.665 2.665 0 002.666-2.666v-7.996",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.375 8.897H7.647a6.397 6.397 0 100 12.794h11.728l9.595 6.397V2.5l-9.595 6.397z",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.75 22.5c2.071 0 3.75-2.518 3.75-5.625s-1.679-5.625-3.75-5.625"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "marketer_svg__clip0_4607_16248"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})));

var SvgMarketer = function SvgMarketer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    color: "#4038ff"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgc3R5bGU9ImNvbG9yOiM0MDM4RkY7IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNDYwN18xNjI0OCkiPgo8cGF0aCBkPSJNNy42NDY5NyAyMS42OTExQzcuNjQ2OTcgMjEuNjkxMSA3LjY0Njk3IDI3LjAyMTkgNy42NDY5NyAyOS4xNTQzVjM1LjAxODJDNy42NDY5NyAzNi40OTAzIDguODQwMzIgMzcuNjgzNiAxMC4zMTI0IDM3LjY4MzZWMzcuNjgzNkMxMS43ODQ1IDM3LjY4MzYgMTIuOTc3OCAzNi40OTAzIDEyLjk3NzggMzUuMDE4MlYyNy4wMjE5IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTE5LjM3NDkgOC44OTcwMkg3LjY0NzAyQzQuMTEzNzMgOC44OTcwMiAxLjI1IDExLjc2MDcgMS4yNSAxNS4yOTRDMS4yNSAxOC44MjczIDQuMTEzNzMgMjEuNjkxMSA3LjY0NzAyIDIxLjY5MTFIMTkuMzc0OUwyOC45NzA0IDI4LjA4ODFWMi41TDE5LjM3NDkgOC44OTcwMloiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMzMuNzUgMjIuNUMzNS44MjExIDIyLjUgMzcuNSAxOS45ODE2IDM3LjUgMTYuODc1QzM3LjUgMTMuNzY4NCAzNS44MjExIDExLjI1IDMzLjc1IDExLjI1IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNDYwN18xNjI0OCI+CjxyZWN0IHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgMarketer as ReactComponent };